export function exchangeRates() {
    const tableHolder = document.querySelector(".exchange-table");
    const table = tableHolder.querySelector("table");
    const time = tableHolder.querySelector("time");

    // fetch("https://api.exchangeratesapi.io/latest?6e008a4dfb2ca561f8f699571d62b5a3?base=USD&symbols=CNY,EUR,JPY,GBP,CHF,AUD,CAD,NZD,HKD,SGD")
    fetch("https://api.exchangeratesapi.io/v1/latest?access_key=6e008a4dfb2ca561f8f699571d62b5a3&base=USD&symbols=CNY,EUR,JPY,GBP,CHF,AUD,CAD,NZD,HKD,SGD")
        .then(response => response.json())
        .then(data => {
            const {rates, date} = data;
            let order = ["CNY", "EUR", "JPY", "GBP", "CHF", "AUD", "CAD", "NZD", "HKD", "SGD"];
            order.forEach(function (item) {
                let tableRow = document.createElement("tr");
                tableRow.innerHTML = `<th scope="row">${item}</th> <td>${rates[item].toFixed(4)}</td>`;
                table.appendChild(tableRow);
            });
            time.textContent = date;
        });
    //
}



// WEBPACK FOOTER //
// ./assets/js/modules/exchangeRates.js